export enum JunctionType {
  AND = 'AND',
  OR = 'OR',
}

export type FilterCondition = {
  type: 'condition';
  filterId: string;
  label: string;
  values: string[];
};

export type FilterAndGroup = {
  type: 'and';
  conditions: FilterCondition[];
};

export type FilterRuleTree = {
  junction: JunctionType;
  groups: FilterAndGroup[];
};
